/*
Item: Recycler Components for removing Cards in
  Drag'n'Drop in Statistics.jsx
Name: Recycler
Format: Code/Frontend component
*/

import React, { Component } from 'react';
// import update from 'immutability-helper'
import { DropTarget } from 'react-dnd';
import Card from './StructureCard';
// import uniqueId from 'lodash/uniqueId';

class Recycler extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { list, id, containerName,
      canDrop, isOver, connectDropTarget, header,
    } = this.props;
    const isActive = canDrop && isOver;
    const style = {
      width: '100%',
      textAlign: 'center',
      padding: '0',
    };
    const backgroundColor = isActive ? 'lightgreen' : '#FFF';

    return connectDropTarget(
      <div className="card" style={{ ...style, backgroundColor }}>
        <span style={{ color: '#999', fontSize: '12px' }}>{header}</span>
        {list.map((card, i) => (
          <Card
            key={card.id}
            activeFilter={card.activeFilter}
            activeRule={card.activeRule}
            showRules={card.showRules}
            index={i}
            listId={id}
            containerName={containerName}
            card={card}
            removeCard={this.removeCard}
            moveCard={this.moveCard}
            showOverlay={this.showOverlay}
          />
        ))}
      </div>,
    );
  }
}

const cardTarget = {
  drop(props) {
    const { id } = props;
    return {
      listId: id,
    };
  },
  canDrop() {
    return true;
  },
};

export default DropTarget('CARD', cardTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
}))(Recycler);
